import { render, staticRenderFns } from "./MachineBackup.vue?vue&type=template&id=ef578a36&scoped=true"
import script from "./MachineBackup.vue?vue&type=script&lang=js"
export * from "./MachineBackup.vue?vue&type=script&lang=js"
import style0 from "./MachineBackup.vue?vue&type=style&index=0&id=ef578a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef578a36",
  null
  
)

export default component.exports